import { createDomain } from 'effector';

import { type EstatePlanProductChoice } from 'types/zod/product-choice';

const domain = createDomain('preselected-assessment');

const $$preselectedAssessment = {
    $productChoice: domain.store<EstatePlanProductChoice | null>(null),

    answerFirstProductQuestionFx: domain.effect<EstatePlanProductChoice, void>(),
};

export default $$preselectedAssessment;
